module.exports = __webpack_public_path__ + "img/icon_hygiene.affb839.svg";